// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});

import { renderSvelteComponent } from './utils/render.js';
import { topojsonToGeoJson } from './utils/geography.js';
import { csv, json } from 'd3-fetch';
import { map } from 'd3-collection';
import { selSystem, selCounty } from './store.js';
import Dashboard from './components/Dashboard.svelte';
import Select from './components/Select.svelte';

import {
  SYSTEMS_URL,
  MONITORING_RESULTS_URL,
  NOTICES_URL,
  GEOGRAPHY_URL,
  VIOLATIONS,
} from './constants.js';

async function main() {
  // Read in your data
  const systems = await csv(SYSTEMS_URL, function (d) {
    return {
      bottled_water_or_hauled_water_reliance_threshold_met:
        d.bottled_water_or_hauled_water_reliance_threshold_met,
      county: d.county,
      current_failing: d.current_failing,
      final_safer_status: d.final_safer_status,
      latitude_measure: +d.latitude_measure,
      longitude_measure: +d.longitude_measure,
      past_presence_on_the_failing_list_threshold_met:
        d.past_presence_on_the_failing_list_threshold_met,
      population: +d.population,
      primary_analytes: d.primary_analytes,
      primary_mcl_violation: d.primary_mcl_violation,
      primary_source: d.primary_source,
      principal_county_served: d.principal_county_served,
      pwsid: d.pwsid,
      risk_assessment_result: d.risk_assessment_result,
      service_area_name: d.service_area_name,
      service_connections: +d.service_connections,
      system_name: d.system_name,
      admin_phone: d.admin_phone,
      admin_email: d.admin_email,
      district: d.district,
      district_phone: d.district_phone,
      district_email: d.district_email,
      water_quality_pct: +d.water_quality_percentage_of_total_risk_score,
      accessibility_pct: +d.accessibility_percentage_of_total_risk_score,
      affordability_pct: +d.affordability_percentage_of_total_risk_score,
      arsenic_treated: +d.arsenic_treated,
      nitrate_treated: +d.nitrate_treated,
      tcp_treated: +d.tcp_treated,
    };
  });

  const monitoring_results = await csv(MONITORING_RESULTS_URL, function (d) {
    return {
      year: new Date(+d.sample_year, 0),
      pwsid: d.pwsid,
      arsenic: d.arsenic,
      nitrate: d.nitrate,
      tcp: d.tcp,
      arsenic_treated: d.arsenic_treated,
      nitrate_treated: d.nitrate_treated,
      tcp_treated: d.tcp_treated,
    };
  });

  const notices = await csv(NOTICES_URL, function (d) {
    return {
      start_date: new Date(d.quarter_start + '-' + d.year),
      end_date: new Date(d.quarter_end + '-' + d.year),
      pwsid: d.pwsid,
      constituent: d.constituent,
      notice_language: +d.notice_language,
    };
  });

  const violations = await csv(VIOLATIONS, function (d) {
    return {
      pwsid: d.pwsid,
      year: new Date(+d.year, 0),
      tcp: +d.tcp,
      arsenic: +d.arsenic,
      nitrate: +d.nitrate,
    };
  });

  const topology = await json(GEOGRAPHY_URL);
  const [geography, cities] = topojsonToGeoJson(topology, [
    'counties',
    'cities',
  ]);

  // Render components
  renderSvelteComponent(Select, document.getElementById('select'), {
    data: systems.map(({ pwsid, system_name, county }) => ({
      pwsid,
      system_name,
      county,
    })),
    counties: map(systems, function (d) {
      return d.county;
    }).keys(),
  });

  renderSvelteComponent(Dashboard, document.getElementById('system-overview'), {
    data: systems,
    monitoring_results: monitoring_results,
    notices: notices,
    violations: violations,
    geography,
    cities,
  });

  // Change the selected system
  const systemSelector = document.getElementById('system-selector');

  systemSelector.onchange = (event) => {
    event.preventDefault();
    selSystem.set(systemSelector.value);
  };

  // Change the selected county
  const countySelector = document.getElementById('county-selector');

  countySelector.onchange = (event) => {
    event.preventDefault();
    selCounty.set(countySelector.value);
    selSystem.set(null);
    systemSelector.classList.remove('disabled');
    systemSelector.selectedIndex = 0;
  };
  // Select a system that has sent a notice
  const noticeSystems = document.querySelectorAll('.radio');

  for (var i = 0; i < noticeSystems.length; i++) {
    noticeSystems[i].onclick = (e) => {
      selSystem.set(e.target.value);
      selCounty.set(e.target.dataset.county);
      systemSelector.classList.remove('disabled');
      var elmntToView = document.getElementById('system-overview');
      elmntToView.scrollIntoView({ behavior: 'smooth' });
    };
  }
}

main();
